<template>
  <section class="pos-admin-page">
    <div class="pos-section-heading"><div><span class="pos-eyebrow">{{ studio.name }}</span><h1>Kassen-Einstellungen</h1></div></div>
    <v-btn-toggle v-model="tab" mandatory class="pos-segments mb-6">
      <v-btn value="billing" :disabled="locked && tab !== 'billing'"><v-icon left small>mdi-file-document-outline</v-icon>Rechnungsdaten</v-btn>
      <v-btn value="accounts" :disabled="locked && tab !== 'accounts'"><v-icon left small>mdi-book-open-variant</v-icon>Ertragskonten</v-btn>
    </v-btn-toggle>
    <pos-billing-settings v-if="tab === 'billing'" :studio-id="studioId" @busy="locked = $event" @notice="$emit('notice', $event)" @failure="$emit('failure', $event)" />
    <pos-account-settings v-else :studio-id="studioId" :context="context" embedded @busy="locked = $event" @notice="$emit('notice', $event)" @failure="$emit('failure', $event)" />
  </section>
</template>
<script>
import PosBillingSettings from "./PosBillingSettings.vue"
import PosAccountSettings from "./PosAccountSettings.vue"
export default {
  inheritAttrs: false, components: { PosBillingSettings, PosAccountSettings },
  props: { studioId: String, studio: { type: Object, default: () => ({}) }, context: Object },
  data: () => ({ tab: "billing", locked: false }),
  watch: { locked(value) { this.$emit("cash-locked", value) } },
  beforeRouteLeave(to, from, next) {
    if (this.locked) { this.$emit("notice", "Bitte Änderungen zuerst speichern oder verwerfen."); next(false) } else next()
  },
  beforeDestroy() { this.$emit("cash-locked", false) },
}
</script>
